Vue.component('store-products-admin-index', {

    props: ['products'],

    ready: function () {
    },

    data: function () {
        return {};
    },

    computed: {},

    methods: {}
});



// WEBPACK FOOTER //
// ./resources/assets/js/store/products/admin/index.js